import styled from 'styled-components'
import { Avatar } from 'antd'
import { COLORS } from './../DesignConstants'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  max-width: 100%;
`

export const AvatarWrapper = styled(Avatar)<{
  size: number
  background: string
  borderradius: number
}>`
  min-width: ${(props) => props.size}px;
  min-height: ${(props) => props.size}px;
  background-color: ${(props) => props.background};
  border-radius: ${(props) => props.borderradius}px;
  svg {
    margin-top: 9px;
  }
`

export const Detail = styled.div<{ withAvatar?: boolean }>`
  display: grid;
  line-height: 1.5;
  padding-left: ${(props) => (props.withAvatar ? '10px' : '0')};
  min-width: 0;
  flex: 1;
  overflow: hidden;
`

export const Title = styled.span<{
  fontWeight: string
  principalColor: string
}>`
  font-weight: ${(props) => props.fontWeight};
  color: ${(props) => props.principalColor} !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px !important;
`

export const Subtitle = styled.small`
  color: ${COLORS.darkGray} !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 11px !important;
`
